module.exports = __webpack_public_path__ + "img/conny-f-stage3-sulking.0629dd43.png";